function _toArray(r) { return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableRest(); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* global React, window, ISSUES, EVENTS, DISPATCH, CAUSES_PCT */
/* global Button, Pill, Eyebrow, Icon, SectionHead */
// ============================================================================
// Editorial sections — Manifesto, Issues, Calendar, Dispatch,
// Testimonials, Newsletter.
// ============================================================================
var _React = React,
  useStateE = _React.useState,
  useRefE = _React.useRef;

// ============================================================================
// MANIFESTO — full-width, generous air, italic serif statement
// ============================================================================
function Manifesto() {
  return /*#__PURE__*/React.createElement("section", {
    id: "manifesto",
    className: "section--lg",
    style: {
      background: "var(--ink-bg)",
      color: "var(--bone)",
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      textAlign: "center",
      maxWidth: 980,
      margin: "0 auto"
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "rust",
    style: {
      color: "var(--rust)"
    }
  }, "The Manifesto \xB7 2026"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: "clamp(40px, 6vw, 96px)",
      lineHeight: 1.05,
      letterSpacing: "-0.015em",
      margin: "32px 0 0",
      color: "var(--bone)"
    }
  }, "We design clothes for people who refuse to be", " ", /*#__PURE__*/React.createElement("em", {
    style: {
      fontStyle: "italic",
      color: "var(--rust)"
    }
  }, "silent"), ",", " ", /*#__PURE__*/React.createElement("em", {
    style: {
      fontStyle: "italic",
      color: "var(--rust)"
    }
  }, "small"), ", or", " ", /*#__PURE__*/React.createElement("em", {
    style: {
      fontStyle: "italic",
      color: "var(--rust)"
    }
  }, "convenient"), "."), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 48,
      fontSize: 18,
      lineHeight: 1.7,
      color: "rgba(244,239,232,0.8)",
      maxWidth: 680,
      margin: "48px auto 0"
    }
  }, "Every thread we print, every dollar we make, every square inch of fabric \u2014 it's a promise. A promise to fund the people doing the work, pay the artists who design it, and tell the truth about where the money goes."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      gap: 14,
      marginTop: 48
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "invert"
  }, "Read in full"), /*#__PURE__*/React.createElement(Button, {
    variant: "link",
    style: {
      color: "var(--bone)"
    }
  }, "Our story ", /*#__PURE__*/React.createElement(Icon, {
    name: "arrowR",
    size: 14
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 80,
      paddingTop: 32,
      borderTop: "1px solid rgba(244,239,232,0.15)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mono",
    style: {
      color: "rgba(244,239,232,0.5)",
      fontSize: 11,
      letterSpacing: "0.12em",
      textTransform: "uppercase"
    }
  }, "Signed \u2014 The R&R Collective \xB7 Brooklyn / Los Angeles"))));
}

// ============================================================================
// ISSUES — editorial dossier list (numbered, hairline-divided)
// ============================================================================
function IssuesBlock(_ref) {
  var onCause = _ref.onCause;
  return /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "What's happening now",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "The issues we won't ", /*#__PURE__*/React.createElement("em", {
      style: {
        fontStyle: "italic"
      }
    }, "look away from.")),
    lede: "A short brief on each. Donate to the organizations doing the work. Wear the design that funds them. Repeat."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: "1px solid var(--line)"
    }
  }, ISSUES.map(function (it, i) {
    return /*#__PURE__*/React.createElement(IssueRow, {
      key: it.id,
      it: it,
      idx: i,
      onCause: onCause
    });
  }))));
}
function IssueRow(_ref2) {
  var it = _ref2.it,
    idx = _ref2.idx,
    onCause = _ref2.onCause;
  var _useStateE = useStateE(false),
    _useStateE2 = _slicedToArray(_useStateE, 2),
    hover = _useStateE2[0],
    setHover = _useStateE2[1];
  return /*#__PURE__*/React.createElement("article", {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: {
      display: "grid",
      gridTemplateColumns: "80px 1.4fr 1.4fr 0.8fr",
      gap: 40,
      padding: "40px 0",
      borderBottom: "1px solid var(--line)",
      alignItems: "flex-start",
      transition: "background 200ms, padding 200ms",
      background: hover ? "var(--shell)" : "transparent",
      paddingLeft: hover ? 24 : 0,
      paddingRight: hover ? 24 : 0
    },
    className: "responsive-issue-row"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-serif)",
      fontStyle: "italic",
      fontSize: 48,
      lineHeight: 1,
      color: hover ? "var(--rust)" : "var(--ink)",
      transition: "color 240ms"
    }
  }, it.id), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "rust"
  }, it.tag), /*#__PURE__*/React.createElement("h3", {
    style: {
      marginTop: 12,
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: 28,
      lineHeight: 1.15,
      color: "var(--ink)",
      margin: "12px 0 0"
    }
  }, it.headline)), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.6,
      color: "var(--muted)",
      margin: 0
    }
  }, it.body), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      alignItems: "flex-start"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: it.orgUrl,
    target: "_blank",
    rel: "noopener",
    style: {
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 13,
      color: "var(--ink)",
      borderBottom: "1px solid var(--ink)",
      paddingBottom: 2
    },
    onMouseEnter: function onMouseEnter(e) {
      e.currentTarget.style.color = "var(--rust)";
      e.currentTarget.style.borderBottomColor = "var(--rust)";
    },
    onMouseLeave: function onMouseLeave(e) {
      e.currentTarget.style.color = "var(--ink)";
      e.currentTarget.style.borderBottomColor = "var(--ink)";
    }
  }, "Donate to ", it.org), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onCause === null || onCause === void 0 ? void 0 : onCause(it.shopId);
    },
    style: {
      background: "transparent",
      border: "none",
      padding: 0,
      cursor: "pointer",
      fontFamily: "var(--font-sans)",
      fontSize: 13,
      color: "var(--muted)",
      display: "inline-flex",
      alignItems: "center",
      gap: 6
    },
    onMouseEnter: function onMouseEnter(e) {
      e.currentTarget.style.color = "var(--ink)";
    },
    onMouseLeave: function onMouseLeave(e) {
      e.currentTarget.style.color = "var(--muted)";
    }
  }, "Wear the cause ", /*#__PURE__*/React.createElement(Icon, {
    name: "arrowR",
    size: 12
  }))), /*#__PURE__*/React.createElement("style", null, "\n        @media (max-width: 900px) {\n          .responsive-issue-row { grid-template-columns: 1fr !important; gap: 14px !important; }\n        }\n      "));
}

// ============================================================================
// CALENDAR — horizontal scroll of events
// ============================================================================
function CalendarBlock(_ref3) {
  var onMore = _ref3.onMore;
  var rail = useRefE(null);
  var scroll = function scroll(d) {
    var _rail$current;
    return (_rail$current = rail.current) === null || _rail$current === void 0 ? void 0 : _rail$current.scrollBy({
      left: d * 380,
      behavior: "smooth"
    });
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    id: "rr-calendar",
    style: {
      background: "var(--shell)",
      borderTop: "1px solid var(--line)",
      borderBottom: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Get off the couch",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Upcoming ", /*#__PURE__*/React.createElement("em", {
      style: {
        fontStyle: "italic"
      }
    }, "actions.")),
    lede: "Marches, rallies, vigils. Bring a friend. Wear something loud.",
    action: /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 8,
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return scroll(-1);
      },
      "aria-label": "Prev",
      style: navBtn
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "arrowL",
      size: 16
    })), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return scroll(1);
      },
      "aria-label": "Next",
      style: navBtn
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "arrowR",
      size: 16
    })), /*#__PURE__*/React.createElement("span", {
      style: {
        width: 12
      }
    }), /*#__PURE__*/React.createElement(Button, {
      variant: "link",
      onClick: onMore
    }, "Full calendar ", /*#__PURE__*/React.createElement(Icon, {
      name: "arrowR",
      size: 14
    })))
  }), /*#__PURE__*/React.createElement("div", {
    ref: rail,
    className: "rr-cal-rail",
    style: {
      display: "grid",
      gridAutoFlow: "column",
      gridAutoColumns: "360px",
      gap: 24,
      overflowX: "auto",
      paddingBottom: 16,
      scrollSnapType: "x mandatory"
    }
  }, EVENTS.map(function (e, i) {
    return /*#__PURE__*/React.createElement(EventCard, {
      key: i,
      ev: e,
      idx: i
    });
  }))));
}
var navBtn = {
  width: 40,
  height: 40,
  background: "transparent",
  color: "var(--ink)",
  border: "1px solid var(--ink)",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
};
function EventCard(_ref4) {
  var ev = _ref4.ev,
    idx = _ref4.idx;
  var _useStateE3 = useStateE(false),
    _useStateE4 = _slicedToArray(_useStateE3, 2),
    hover = _useStateE4[0],
    setHover = _useStateE4[1];
  return /*#__PURE__*/React.createElement("article", {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: {
      background: hover ? "var(--ink)" : "var(--paper)",
      color: hover ? "var(--bone)" : "var(--ink)",
      border: "1px solid var(--line)",
      scrollSnapAlign: "start",
      padding: 28,
      display: "flex",
      flexDirection: "column",
      gap: 18,
      transition: "background 220ms, color 220ms, transform 220ms",
      transform: hover ? "translateY(-4px)" : "translateY(0)",
      minHeight: 360
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 11,
      letterSpacing: "0.16em",
      textTransform: "uppercase",
      color: hover ? "var(--rust)" : "var(--muted)"
    }
  }, ev.date.split(" ")[0]), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-serif)",
      fontSize: 64,
      lineHeight: 0.9,
      marginTop: 4
    }
  }, ev.date.split(" ")[1])), /*#__PURE__*/React.createElement(Pill, {
    tone: hover ? "bone" : "neutral",
    style: hover ? {
      background: "var(--bone)",
      color: "var(--ink)",
      border: "none"
    } : {}
  }, ev.type)), /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontFamily: "var(--font-serif)",
      fontStyle: hover ? "italic" : "normal",
      fontSize: 26,
      lineHeight: 1.15,
      transition: "font-style 200ms"
    }
  }, ev.title), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      fontSize: 14,
      color: hover ? "rgba(244,239,232,0.85)" : "var(--muted)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 8,
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "pin",
    size: 14
  }), " ", ev.city, " \xB7 ", ev.place), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 8,
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "clock",
    size: 14
  }), " ", ev.time)), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto",
      paddingTop: 16,
      borderTop: "1px solid " + (hover ? "rgba(244,239,232,0.2)" : "var(--line)"),
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12,
      color: hover ? "rgba(244,239,232,0.7)" : "var(--muted)"
    }
  }, "Hosted by ", ev.host), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 12,
      color: hover ? "var(--rust)" : "var(--ink)",
      display: "inline-flex",
      gap: 6,
      alignItems: "center",
      borderBottom: "1px solid " + (hover ? "var(--rust)" : "var(--ink)"),
      paddingBottom: 1
    }
  }, "I'm in ", /*#__PURE__*/React.createElement(Icon, {
    name: "arrowR",
    size: 12
  }))));
}

// ============================================================================
// DISPATCH — editorial blog. Feature article + 3 list rows.
// ============================================================================
function DispatchBlock() {
  var _DISPATCH = DISPATCH,
    _DISPATCH2 = _toArray(_DISPATCH),
    feat = _DISPATCH2[0],
    rest = _arrayLikeToArray(_DISPATCH2).slice(1);
  return /*#__PURE__*/React.createElement("section", {
    className: "section",
    id: "rr-dispatch",
    style: {
      background: "var(--shell)",
      borderTop: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "The Dispatch \u2014 journal",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "Read up. ", /*#__PURE__*/React.createElement("em", {
      style: {
        fontStyle: "italic"
      }
    }, "Then act up.")),
    lede: "Activist tactics, movement history, and the stories behind the designs.",
    action: /*#__PURE__*/React.createElement(Button, {
      variant: "link",
      onClick: function onClick() { window.location.href = '/blogs/the-dispatch'; }
    }, "All entries ", /*#__PURE__*/React.createElement(Icon, {
      name: "arrowR",
      size: 14
    }))
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1.4fr 1fr",
      gap: 64
    },
    className: "responsive-2col"
  }, /*#__PURE__*/React.createElement(FeatureArticle, {
    d: feat
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, rest.map(function (d, i) {
    return /*#__PURE__*/React.createElement(DispatchRow, {
      key: d.id,
      d: d,
      first: i === 0
    });
  })))));
}
function FeatureArticle(_ref5) {
  var d = _ref5.d;
  var _useStateE5 = useStateE(false),
    _useStateE6 = _slicedToArray(_useStateE5, 2),
    hover = _useStateE6[0],
    setHover = _useStateE6[1];
  return /*#__PURE__*/React.createElement("article", {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    onClick: function onClick() {
      window.location.href = '/blogs/the-dispatch/' + d.id;
    },
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      aspectRatio: "4 / 3",
      background: "var(--ink)",
      position: "relative",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      background: "linear-gradient(135deg, #2A2A28 0%, #0D0D0D 100%)"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      background: "radial-gradient(circle at 70% 30%, rgba(178,58,44,0.35), transparent 60%)",
      transition: "opacity 360ms",
      opacity: hover ? 1 : 0.6
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 56
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-serif)",
      fontStyle: "italic",
      fontSize: "clamp(36px, 4.2vw, 64px)",
      lineHeight: 1.05,
      color: "var(--bone)",
      textAlign: "center",
      letterSpacing: "-0.01em"
    }
  }, "\"", d.title.split('—')[0].replace(/\?$/, '?'), "\"")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      top: 20,
      left: 20,
      display: "flex",
      gap: 6
    }
  }, d.tags.slice(0, 2).map(function (t) {
    return /*#__PURE__*/React.createElement("span", {
      key: t,
      style: {
        fontFamily: "var(--font-mono)",
        fontSize: 10,
        padding: "4px 8px",
        background: "rgba(244,239,232,0.18)",
        color: "var(--bone)",
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)"
      }
    }, t);
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: 24
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, null, "Feature \xB7 ", d.read), /*#__PURE__*/React.createElement("h3", {
    style: {
      marginTop: 14,
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: 32,
      lineHeight: 1.15,
      color: "var(--ink)",
      margin: "14px 0 0"
    }
  }, d.title), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 14,
      fontSize: 15,
      color: "var(--muted)",
      lineHeight: 1.6
    }
  }, d.dek), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 20,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingTop: 16,
      borderTop: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-sans)",
      fontSize: 12,
      letterSpacing: "0.08em",
      color: "var(--muted)",
      textTransform: "uppercase"
    }
  }, "The Dispatch \xB7 ", d.date), /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      gap: 8,
      alignItems: "center",
      fontSize: 13,
      color: hover ? "var(--rust)" : "var(--ink)",
      borderBottom: "1px solid " + (hover ? "var(--rust)" : "var(--ink)"),
      paddingBottom: 1,
      transition: "color 160ms, border-color 160ms"
    }
  }, "Read story ", /*#__PURE__*/React.createElement(Icon, {
    name: "arrowR",
    size: 12
  })))));
}
function DispatchRow(_ref6) {
  var d = _ref6.d,
    first = _ref6.first;
  var _useStateE7 = useStateE(false),
    _useStateE8 = _slicedToArray(_useStateE7, 2),
    hover = _useStateE8[0],
    setHover = _useStateE8[1];
  return /*#__PURE__*/React.createElement("a", {
    href: '/blogs/the-dispatch/' + d.id,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 10,
      padding: "28px 0",
      borderTop: first ? "1px solid var(--line)" : "1px solid var(--line)",
      color: "var(--ink)",
      paddingLeft: hover ? 16 : 0,
      transition: "padding 200ms"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: 6
    }
  }, d.tags.slice(0, 2).map(function (t) {
    return /*#__PURE__*/React.createElement("span", {
      key: t,
      style: {
        fontFamily: "var(--font-mono)",
        fontSize: 10,
        color: "var(--muted)",
        textTransform: "uppercase",
        letterSpacing: "0.06em"
      }
    }, t);
  })), /*#__PURE__*/React.createElement("h4", {
    style: {
      margin: 0,
      fontFamily: "var(--font-serif)",
      fontStyle: hover ? "italic" : "normal",
      fontWeight: 400,
      fontSize: 22,
      lineHeight: 1.2,
      color: hover ? "var(--rust)" : "var(--ink)",
      transition: "color 160ms, font-style 160ms"
    }
  }, d.title), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      color: "var(--muted)",
      letterSpacing: "0.06em"
    }
  }, d.date, " \xB7 ", d.read));
}

// ============================================================================
// TESTIMONIALS — clean 3-up
// ============================================================================
function Testimonials() {
  var QUOTES = [{
    q: "Finally a brand that puts its money where its mouth is. The quality is incredible and the cause feels honest, not performative.",
    who: "Sarah M.",
    role: "Verified buyer · Brooklyn"
  }, {
    q: "Wore my tee to three different protests this month. Got compliments and started conversations I wouldn't have had otherwise.",
    who: "David K.",
    role: "Verified buyer · Portland"
  }, {
    q: "Bought the Feminist collection tee as a gift. She cried. The brand just gets it — fast shipping, great quality, designs that mean something.",
    who: "Maya T.",
    role: "Verified buyer · Atlanta"
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(SectionHead, {
    eyebrow: "Field notes",
    title: /*#__PURE__*/React.createElement(React.Fragment, null, "From the ", /*#__PURE__*/React.createElement("em", {
      style: {
        fontStyle: "italic"
      }
    }, "people"), " who wear it.")
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: 0,
      borderTop: "1px solid var(--line)",
      borderBottom: "1px solid var(--line)"
    },
    className: "responsive-3col"
  }, QUOTES.map(function (q, i) {
    return /*#__PURE__*/React.createElement("figure", {
      key: i,
      style: {
        margin: 0,
        padding: 40,
        display: "flex",
        flexDirection: "column",
        gap: 24,
        borderLeft: i > 0 ? "1px solid var(--line)" : "none"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: 2
      }
    }, [0, 1, 2, 3, 4].map(function (s) {
      return /*#__PURE__*/React.createElement(Icon, {
        key: s,
        name: "star",
        size: 14,
        color: "var(--rust)"
      });
    })), /*#__PURE__*/React.createElement("blockquote", {
      style: {
        margin: 0,
        fontFamily: "var(--font-serif)",
        fontStyle: "italic",
        fontSize: 22,
        lineHeight: 1.4,
        color: "var(--ink)"
      }
    }, "\"", q.q, "\""), /*#__PURE__*/React.createElement("figcaption", {
      style: {
        marginTop: "auto"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        fontFamily: "var(--font-sans)",
        fontWeight: 500,
        fontSize: 13
      }
    }, q.who), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 12,
        color: "var(--muted)",
        marginTop: 2
      }
    }, q.role)));
  }))));
}

// ============================================================================
// NEWSLETTER — quiet, single row
// ============================================================================
function Newsletter() {
  var _useStateE9 = useStateE(""),
    _useStateE0 = _slicedToArray(_useStateE9, 2),
    email = _useStateE0[0],
    setEmail = _useStateE0[1];
  var _useStateE1 = useStateE(false),
    _useStateE10 = _slicedToArray(_useStateE1, 2),
    done = _useStateE10[0],
    setDone = _useStateE10[1];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: "var(--ink-bg)",
      color: "var(--bone)",
      padding: "96px 0"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "1.2fr 1fr",
      gap: 80,
      alignItems: "center"
    },
    className: "responsive-2col"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "rust",
    style: {
      color: "var(--rust)"
    }
  }, "Stay close"), /*#__PURE__*/React.createElement("h2", {
    style: {
      marginTop: 24,
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: "clamp(40px, 5.4vw, 84px)",
      lineHeight: 1.02,
      letterSpacing: "-0.02em",
      color: "var(--bone)"
    }
  }, "Drops, dispatches, ", /*#__PURE__*/React.createElement("em", {
    style: {
      fontStyle: "italic"
    }
  }, "direct.")), /*#__PURE__*/React.createElement("p", {
    style: {
      marginTop: 20,
      color: "rgba(244,239,232,0.7)",
      fontSize: 16,
      maxWidth: 480
    }
  }, "New designs, organizing news, the occasional dispatch from the field. No spam. Unsubscribe in one click.")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      if (email) setDone(true);
    },
    style: {
      display: "flex",
      borderBottom: "1px solid var(--bone)",
      paddingBottom: 8
    }
  }, /*#__PURE__*/React.createElement("input", {
    value: email,
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    },
    placeholder: "you@everywhere.com",
    style: {
      flex: 1,
      background: "transparent",
      border: "none",
      outline: "none",
      color: "var(--bone)",
      fontFamily: "var(--font-sans)",
      fontSize: 18,
      padding: "12px 0"
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    style: {
      background: "transparent",
      border: "none",
      color: "var(--bone)",
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 14,
      letterSpacing: "0.04em",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      gap: 8
    }
  }, done ? "Subscribed ✓" : "Subscribe →")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 18,
      display: "flex",
      justifyContent: "space-between",
      fontSize: 11,
      letterSpacing: "0.12em",
      color: "rgba(244,239,232,0.5)",
      textTransform: "uppercase"
    }
  }, /*#__PURE__*/React.createElement("span", null, "14,800+ subscribers"), /*#__PURE__*/React.createElement("span", null, "One email / week"))))));
}
Object.assign(window, {
  Manifesto: Manifesto,
  IssuesBlock: IssuesBlock,
  CalendarBlock: CalendarBlock,
  DispatchBlock: DispatchBlock,
  Testimonials: Testimonials,
  Newsletter: Newsletter
});
